import { createAction, createRequestTypes, createRequestActions } from './utils';
import keyMirror from 'react-utils/keyMirror';
export const HubUsersActionTypes = keyMirror({
  LOAD_HUB_USERS: null,
  FETCH_HUB_USERS: null
});
export const FetchHubUsersActionTypes = createRequestTypes(HubUsersActionTypes.FETCH_HUB_USERS);
export const FetchHubUsers = createRequestActions(FetchHubUsersActionTypes);
export const loadHubUsers = () => createAction(HubUsersActionTypes.LOAD_HUB_USERS);